import { usePermissions } from '@/hooks/usePermissions';

export interface PropertyPermissions {
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export function usePropertyPermissions(): PropertyPermissions {
  const { hasPermission } = usePermissions();
  return {
    canCreate: hasPermission('ahoy_property_type', 'ahoy_object_created'),
    canEdit: hasPermission('ahoy_property_type', 'ahoy_property_updated'),
    canDelete: hasPermission('ahoy_property_type', 'ahoy_object_deleted'),
  };
}
